/** @format */

import { Box, Image, Text } from "@chakra-ui/react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { BoxVigencia } from "../../../components/CardComponents/BoxVigencia";
import { CardHeader } from "../../../components/CardComponents/CardHeader";
import { ContentPrice } from "../../../components/CardComponents/ContentPrice";
import { useRecomendacao } from "../../../context/useRecomendacao";
import { formatDataAtivacao, validaValidadede } from "../../../utils";
import { usePersonalizacao } from "../../../context/usePersonalizacao";
import { Header } from "../../../components/Header";
import { ButtonAtivaDesconto } from "../../../components/CardComponents/ButtonAtivaDesconto";
import { ShareButton } from "../../../components/CardComponents/ShareButton";

export function Descricao() {
  const { selectedOferta, recomendacao, viewDescricao } = useRecomendacao();
  const {
    personalizacao: { card },
  } = usePersonalizacao();
  const { idoferta: idofertaParam } = useParams();

  const {
    //HEADER
    id_classificacao_topete,

    //PRODUTO
    idoferta,
    idtiporecomendacao,
    nomeoferta,
    valorde,
    percentualdesconto,
    valorpor,
    quantidadeparcelas,
    valorparcelas,
    observacao,
    eans,
    ofertagenerica,

    //VALIDADE
    limitecompra,
    saldoutilizado,
    validadede,
    validadeate,

    //IMAGENS
    imagem,
    selopromocao,
    seloClube,

    //ESTADO
    esgotado,
    validoapartir = validaValidadede({
      validadede: selectedOferta.validadede,
    }),
    ativado,
    dataativacao,
  } = selectedOferta;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  useEffect(() => {
    if (Object.keys(selectedOferta).length > 0) {
      return;
    } else {
      if (recomendacao.length > 0) {
        const filtered = recomendacao.filter(
          (data) => String(data.idoferta) === String(idofertaParam),
        )[0];
        viewDescricao(filtered);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recomendacao]);

  if (recomendacao.length > 0) {
    return (
      <Box
        maxWidth="900px"
        margin="0 auto"
        background="white"
        overflow="hidden"
        display="flex"
        flexDir="column"
        justifyContent="space-between">
        <Box>
          <Header />
          <CardHeader
            props={{
              id_classificacao_topete: id_classificacao_topete,
              validadede: validadede,
              idtiporecomendacao: idtiporecomendacao,
            }}
            descricao={true}
          />
          <Box padding="1rem" marginTop="1rem">
            {/* Image Section */}
            <Box display="flex" flexDir="row" justifyContent="space-between">
              <Box filter={validoapartir ? "grayscale(1)" : "grayscale(0)"}>
                {selopromocao ? (
                  <Image w="50px" h="50px" src={selopromocao} />
                ) : !selopromocao && seloClube ? (
                  <Image w="50px" h="50px" src={seloClube} />
                ) : (
                  <Box w="50px" h="50px" />
                )}
                <Box filter={validoapartir ? "grayscale(1)" : "grayscale(0)"}>
                  {seloClube && selopromocao ? (
                    <Image w="50px" h="50px" src={seloClube} />
                  ) : (
                    <Box w="50px" h="50px" />
                  )}
                </Box>
              </Box>
              <Box
                marginX="0.3125rem"
                filter={validoapartir ? "grayscale(1)" : "grayscale(0)"}>
                <Image
                  objectFit="contain"
                  width="136px"
                  height="136px"
                  src={imagem}
                />
              </Box>
              {ofertagenerica === "Y" ? (
                <ShareButton produto={selectedOferta} descricao />
              ) : (
                <Box w="50px" h="50px" borderRadius="full" />
              )}
            </Box>

            {/* ContainerTextProduto */}
            <Box whiteSpace="normal" paddingTop="1rem" paddingBottom="0.25rem">
              <Text
                fontSize="0.75rem"
                fontWeight="black"
                color={validoapartir ? "#70747D" : "#3E4047"}>
                {nomeoferta}
              </Text>
            </Box>

            <ContentPrice
              oferta={idtiporecomendacao === "2"}
              desconto={idtiporecomendacao === "1"}
              cashback={idtiporecomendacao === "3"}
              isHorizontal
              props={{
                valorde: valorde,
                valorpor: valorpor,
                percentualdesconto: percentualdesconto,
                validadede: validadede,
                quantidadeparcelas: quantidadeparcelas,
                valorparcelas: valorparcelas,
                esgotado: esgotado,
              }}
            />

            {idtiporecomendacao === "1" && dataativacao && (
              <Text fontSize="0.75rem" color="#555861" mt="4">
                Você ativou esta oferta em{" "}
                <strong>
                  {formatDataAtivacao(dataativacao, true).split(" ")[0]}
                </strong>{" "}
                às{" "}
                <strong>
                  {formatDataAtivacao(dataativacao, true).split(" ")[1]}
                </strong>
              </Text>
            )}

            <BoxVigencia
              props={{ validadede: validadede, validoapartir: validoapartir }}
              detalhes
            />

            {esgotado && idtiporecomendacao === "3" && (
              <Box
                background="#70747D"
                borderRadius="sm"
                display="flex"
                alignItems="center"
                justifyContent="center"
                marginTop="0.75rem"
                paddingX="0.5625rem"
                paddingY="0.5rem">
                <Text
                  color="#FFFFFF"
                  fontSize="0.75rem"
                  fontWeight="bold"
                  textAlign="center">
                  Esgotado
                </Text>
              </Box>
            )}
            {limitecompra ? (
              <Box paddingTop="1rem">
                <Text color="#555861" fontSize="0.75rem">
                  {card.textValidadeCompradas && idtiporecomendacao === "1" ? (
                    <span>
                      Limitado a{" "}
                      <strong style={{ fontWeight: "bold" }}>
                        {limitecompra}
                      </strong>{" "}
                      | Compradas:{" "}
                      <strong style={{ fontWeight: "bold" }}>
                        {saldoutilizado}
                      </strong>
                    </span>
                  ) : (
                    <span>
                      Limite por CPF:{" "}
                      <strong style={{ fontWeight: "bold" }}>
                        {limitecompra}
                      </strong>
                    </span>
                  )}
                </Text>
              </Box>
            ) : null}

            <Box paddingTop="0.5rem" paddingBottom="0.25rem">
              <Text color="#555861" fontSize="0.75rem" paddingBottom="0.5rem">
                {observacao}
              </Text>
              {validadede && validadeate && (
                <Text color="#555861" fontSize="0.75rem">
                  <span>
                    Oferta válida de
                    <br />
                    <strong style={{ fontWeight: "bold" }}>
                      {"\n"}
                      {new Intl.DateTimeFormat("pt-BR", {
                        timeZone: "UTC",
                      }).format(new Date(validadede))}
                    </strong>{" "}
                    até{" "}
                    <strong style={{ fontWeight: "bold" }}>
                      {new Intl.DateTimeFormat("pt-BR", {
                        timeZone: "UTC",
                      }).format(new Date(validadeate))}
                    </strong>
                  </span>
                </Text>
              )}
            </Box>

            {idtiporecomendacao !== "3" && (
              <Box paddingTop="0.5rem" paddingBottom="0.25rem">
                {card.descricaoadicional &&
                  <Text color="#555861" fontSize="0.75rem" marginY="0.25rem">
                    <div dangerouslySetInnerHTML={{__html: card.descricaoadicional}}></div>
                  </Text>
                }
                {!card.descricaoadicional &&
                  <>
                    <Text color="#555861" fontSize="0.75rem" marginY="0.25rem">
                      Oferta válida enquanto durarem os estoques.
                    </Text>
                    <Text color="#555861" fontSize="0.75rem" marginY="0.25rem">
                      É proibida a venda de bebidas alcoolicas para menores de
                      idade.
                    </Text>
                  </>
                }
              </Box>
            )}

            {idtiporecomendacao === "3" && (
              <Box paddingTop="1rem">
                <Text fontSize="0.75rem" color="#555861">
                  {esgotado
                    ? "Dinheiro de volta esgotado para este produto."
                    : "Válido enquanto durarem os estoques disponíveis para esta promoção."}
                </Text>
              </Box>
            )}

            {eans?.length && idtiporecomendacao !== "2" && (
              <Box paddingY="1rem">
                <Text fontWeight="bold" color="#555861" fontSize="0.75rem">
                  Códigos participantes:
                </Text>
                <Text color="#555861" fontSize="0.75rem">
                  {eans.map((data) => `${data}; `)}
                </Text>
              </Box>
            )}
          </Box>
        </Box>

        {idtiporecomendacao === "1" && (
          <Box padding="1rem">
            <ButtonAtivaDesconto
              descricao
              horizontal
              props={{
                idoferta: idoferta,
                validadede: validadede,
                validadeate: validadeate,
                ativado: ativado,
                dataativacao: dataativacao,
              }}
            />
          </Box>
        )}
      </Box>
    );
  } else {
    return (
      <Box
        maxWidth="900px"
        margin="0 auto"
        background="white"
        overflow="hidden">
        <Header />
        Erro ao carrega oferta: {idofertaParam}
      </Box>
    );
  }
}
